<template>
  <Wrapper>
    <main class="main">
      <!-- パンくず -->
      <ol class="breadcrumb-trail__list">
        <li class="breadcrumb-trail__list--item">
          <router-link
            :to="{ path: `/${langPath}` }"
            class="breadcrumb-trail__list--item__link"
          >
            TOP
          </router-link>
        </li>
        <li class="breadcrumb-trail__list--item">
          <router-link
            :to="{ path: `/${langPath}link` }"
            class="breadcrumb-trail__list--item__link"
          >
            {{ Link.title[lang] }}
          </router-link>
        </li>
      </ol>
      <!-- 再読み込み画面 -->
      <section v-if="!referrerData" class="oauth-result-section">
        <p>{{ Link.reload[lang] }}</p>
        <div class="reload-link">
          <img src="../../../assets/images/triangle-right-purple.svg" alt="" />
          <router-link
            :to="{ path: `/${langPath}confirmation` }"
            class="link t-underline"
          >
            {{ Link.guide[lang] }}
          </router-link>
        </div>
        <div class="coop-link">
          <img src="../../../assets/images/triangle-right-purple.svg" alt="" />
          <span class="link">
            {{ Link.doneSentence3[lang]
            }}<a
              :href="`${Link.pdf[lang]}`"
              class="t-underline"
              target="_blank"
              rel="noopener"
              >{{ Link.here[lang] }}</a
            >
          </span>
        </div>
        <RunkeeperCapture :link="Link" :lang="lang"></RunkeeperCapture>
      </section>
      <!-- 成功 -->
      <section v-if="isRegister && referrerData" class="oauth-result-section">
        <p class="coop-sentence">
          {{ Link.done[lang] }}
        </p>
        <div class="margin-t40">{{ Link.doneSentence[lang] }}</div>
        <div class="app-name"
          >{{ Link.doneSentence2[lang] }}&nbsp;{{ runnerName }}</div
        >
        <div class="coop-link">
          <img src="../../../assets/images/triangle-right-purple.svg" alt="" />
          <router-link
            :to="{ path: `/${langPath}confirmation` }"
            class="link t-underline"
          >
            {{ Link.return[lang] }}
          </router-link>
        </div>
        <div class="coop-link">
          <img src="../../../assets/images/triangle-right-purple.svg" alt="" />
          <span class="link">
            {{ Link.doneSentence3[lang]
            }}<a
              :href="`${Link.pdf[lang]}`"
              class="t-underline"
              target="_blank"
              rel="noopener"
              >{{ Link.here[lang] }}</a
            >
          </span>
        </div>
        <RunkeeperCapture :link="Link" :lang="lang"></RunkeeperCapture>
      </section>
      <!-- 失敗 -->
      <section v-if="!isRegister && referrerData" class="oauth-result-section">
        <p class="coop-sentence">
          {{ Link.error[lang] }}
        </p>
        <div class="coop-link">
          <img src="../../../assets/images/triangle-right-purple.svg" alt="" />
          <router-link
            :to="{ path: `/${langPath}confirmation` }"
            class="link t-underline"
          >
            {{ Link.return[lang] }}
          </router-link>
        </div>
      </section>
    </main>
  </Wrapper>
</template>

<script>
import Wrapper from "../../../components/sp/Wrapper";
import RunkeeperCapture from "../../../components/sp/oauth/RunkeeperCapture";
import Link from "../../../assets/constants/link/link";
export default {
  data() {
    return {
      referrerData: null,
      isRegister: null,
      runnerName: "",
    };
  },
  created() {
    // リロード時
    // 2020/11 performanceNavigationTiming.type はsafari非対応のため使用してない
    if (window.performance.navigation.type === 1) {
      this.referrerData = 0;
      return;
    }
    // 成功判定
    this.isRegister = this.$route.query.register === "success";
    this.runnerName = this.$route.query.runner_name;
    if (
      document.referrer.includes("https://dev.tmf-virtualrun.jp") ||
      document.referrer.includes("https://tmf-virtualrun.jp") ||
      document.referrer.includes("https://runkeeper.com")
    ) {
      this.referrerData = 1;
      return;
    }
    this.referrerData = 0;
  },
  computed: {
    Link: function () {
      return Link;
    },
    lang: function () {
      return this.$store.state.lang;
    },
    langPath: function () {
      return this.$store.state.langPath;
    },
  },
  components: {
    Wrapper,
    RunkeeperCapture,
  },
  name: "Link",
};
</script>

<style scoped>
.main {
  .oauth-result-section {
    margin: 40px 0 0 0;
    .reload-link,
    .coop-link {
      margin: 26px 0 0 0;
      display: flex;
      align-items: center;
      .link {
        margin: 0 0 0 10px;
        color: var(--defaultBlackColor);
      }
    }
    .coop-sentence {
      text-align: center;
      font-size: 32px;
    }
    .margin-t40 {
      margin: 40px 0 0 0;
    }
    .app-name {
      margin: 40px 0;
      text-align: center;
      font-size: 24px;
      font-weight: bold;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/sp/link/Link.vue